import { white, primary2 } from "@shane-collective/design-system";
import { Text, styled } from "tamagui";

export const Title = styled(Text, {
  fontFamily: "$rethinkSans",
  fontWeight: "$semibold",
  fontSize: "$sm",
  textAlign: "center",
  color: white,
  paddingTop: 10,
  paddingBottom: 10,
});

export const Body = styled(Text, {
  fontFamily: "$rethinkSans",
  fontWeight: "$normal",
  fontSize: "$sm",
  textAlign: "center",
  color: white,
  paddingTop: 10,
  paddingBottom: 10,
});

export const Label = styled(Text, {
  fontFamily: "$rethinkSans",
  fontWeight: "$semisemibold",
  fontSize: "$sm",
  textAlign: "right",
  color: primary2,
  width: "100px",
});

export const LabelSmall = styled(Text, {
  fontFamily: "$rethinkSans",
  fontWeight: "$semisemibold",
  fontSize: "$sm",
  textAlign: "left",
  color: primary2,
});

export const PermissionLabel = styled(Text, {
  fontFamily: "$rethinkSans",
  fontWeight: "$semibold",
  fontSize: "$sm",
  textAlign: "center",
  color: white,
});

export const Helptext = styled(Text, {
  fontFamily: "$rethinkSans",
  fontWeight: "$normal",
  fontSize: "$xs",
  textAlign: "center",
  color: white,
  fontStyle: "italic",
});
